"use client";
import React from "react";
import * as _Builtin from "./_Builtin";
import * as _utils from "./utils";
import _styles from "./Header.module.css";

export function Header({ as: _Component = _Builtin.Section }) {
  return (
    <_Component
      className={_utils.cx(_styles, "brix---section-extra-small")}
      grid={{
        type: "section",
      }}
      tag="div"
    >
      <_Builtin.Image
        loading="lazy"
        width="auto"
        height="auto"
        alt=""
        src="https://cdn.prod.website-files.com/6356e5735110b93b46145859/644efc4cf64cdc6d7b12b0d0_hero-efl.jpg"
      />
      <_Builtin.Block className={_utils.cx(_styles, "text-block-8")} tag="div">
        {"Weekly Tournaments starting"}
        <_Builtin.Strong>{" May 2023"}</_Builtin.Strong>
      </_Builtin.Block>
    </_Component>
  );
}
